import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function CTA() {
  const navigate = useNavigate();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3
  });
  return <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 relative overflow-hidden" data-id="element-161">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10" data-id="element-162">
        <motion.div className="absolute top-0 left-0 w-96 h-96 bg-green-500 rounded-full blur-3xl" animate={{
        scale: [1, 1.5, 1],
        x: [0, 100, 0],
        y: [0, 50, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-163" />
      </div>
      <div className="max-w-5xl mx-auto px-6 text-center relative z-10" data-id="element-164">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-165">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-166">
            Fluency is <span className="text-green-400" data-id="element-167">Freedom</span>
          </h2>
          <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-3xl mx-auto" data-id="element-168">
            Begin your journey today and unlock opportunities across borders,
            cultures, and careers
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-169">
            <Link to="courses" smooth={true} duration={800} className="bg-green-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-all duration-200 cursor-pointer shadow-xl hover:shadow-2xl flex items-center justify-center gap-2 group" data-id="element-170">
              Join a Class
              <ArrowRightIcon className="group-hover:translate-x-1 transition-transform duration-200" size={20} data-id="element-171" />
            </Link>
            <button onClick={() => navigate('/free-assessment')} className="bg-white text-slate-900 px-10 py-4 rounded-full text-lg font-semibold hover:bg-slate-100 transition-all duration-200 shadow-xl hover:shadow-2xl" data-id="element-172">
              Book Free Assessment
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}